import { render, staticRenderFns } from "./templateAgeGroup.vue?vue&type=template&id=6a50282c"
import script from "./templateAgeGroup.vue?vue&type=script&lang=js"
export * from "./templateAgeGroup.vue?vue&type=script&lang=js"
import style0 from "./templateAgeGroup.vue?vue&type=style&index=0&id=6a50282c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports